import { jsx } from 'react/jsx-runtime';
import { DecoratorNode } from 'lexical';
import ImageComponent from './ImageComponent.mjs';

class ImageNode extends DecoratorNode {
  constructor(src, maxWidth, width, height, key) {
    super(key);
    this.__src = src;
    this.__width = width || "inherit";
    this.__height = height || "inherit";
    this.__maxWidth = maxWidth;
  }
  static getType() {
    return "image";
  }
  static clone(node) {
    return new ImageNode(
      node.__src,
      node.__maxWidth,
      node.__width,
      node.__height,
      node.__key
    );
  }
  static importDOM() {
    return {
      img: (_node) => ({
        conversion: convertImageNode,
        priority: 2
      })
    };
  }
  exportDOM() {
    const element = document.createElement("img");
    element.setAttribute("src", this.__src);
    element.setAttribute("width", this.__width.toString());
    element.setAttribute("height", this.__height.toString());
    element.style.maxWidth = this.__maxWidth?.toString() ?? "100%";
    return { element };
  }
  static importJSON(serializedNode) {
    const { src, width, height, maxWidth } = serializedNode;
    return $createImageNode({ src, width, height, maxWidth });
  }
  exportJSON() {
    return {
      type: "image",
      src: this.getSrc(),
      width: this.__width === "inherit" ? 0 : this.__width,
      height: this.__height === "inherit" ? 0 : this.__height,
      maxWidth: typeof this.__maxWidth === "number" ? this.__maxWidth : void 0,
      version: 1
    };
  }
  createDOM(config) {
    const span = document.createElement("span");
    const theme = config.theme;
    const className = theme.image;
    if (className !== void 0) {
      span.className = className;
    }
    return span;
  }
  updateDOM() {
    return false;
  }
  decorate() {
    return /* @__PURE__ */ jsx(
      ImageComponent,
      {
        nodeKey: this.getKey(),
        src: this.getSrc(),
        width: this.__width,
        height: this.__height,
        maxWidth: this.__maxWidth
      }
    );
  }
  getSrc() {
    return this.__src;
  }
  setSize(width, height) {
    const writable = this.getWritable();
    writable.__width = width;
    writable.__height = height;
  }
}
function convertImageNode(domNode) {
  if (domNode instanceof HTMLImageElement) {
    const { src, width, height } = domNode;
    const node = $createImageNode({ src, width, height });
    return { node };
  }
  return null;
}
function $createImageNode({
  height,
  maxWidth,
  src,
  width,
  key
}) {
  return new ImageNode(src, maxWidth, width, height, key);
}
function $isImageNode(node) {
  return node instanceof ImageNode;
}

export { $createImageNode, $isImageNode, ImageNode };
//# sourceMappingURL=ImageNode.mjs.map
